import { createFilterStateHook } from 'features/filters';
import { ISearchApplication } from 'types/applications';

export const useApplicantsFilterState = createFilterStateHook();

export const mapKeyToSortKey: Partial<Record<keyof ISearchApplication, string>> = {
  averageReviews: 'rating',
  jobStageName: 'stage',
  jobTitle: 'job',
  numMessages: 'num_messages',
  numNotes: 'num_notes',
  numReviews: 'num_rating',
};

export const pageSize = 1000;
